<script>
export default {
  name: "StatisticsHeader",

  data: () => ({}),
  props: {
    title: String,
    value: String,
  },
};
</script>
<style>
.statistics {
  border-left: 2px solid var(--v-blue-base);
}
</style>
<template>
  <v-col
    id="statisticsHeader"
    cols="12"
    md="1"
    class="d-flex align-center justify-center justify-md-start pa-0"
  >
    <v-sheet class="d-flex statistics" width="80%">
      <h5 class="blue--text">{{ $t(title) }}</h5>
      <h6 class="blue--text mt-2 mr-1">{{ `(${$t(value)})` }}</h6>
      <v-divider color="gray0" vertical class="mr-3"></v-divider>
    </v-sheet>
  </v-col>
</template>
